import { environment } from "../../../environments/environment";
import { autoFillFiller } from "./auto-fill-forms-filler";

export interface AutoFillFormsOptions {
  shouldSubmit?: boolean;
  keyBinded?: "Alt + A" | "Alt + Q" | "Alt + E";
  formData?: any;
}

let EventListnerwasAdded = false;

/** This is a development only helper function
 * for quick form filling. runs only in development env.
 * To operate it needs to be imported to the component level
 * @param {any} componentRef - the pointer to the component,
 * the 'this' in each component
 * @param {AutoFillFormsOptions} options for auto submit, different keys and specific data to pass.
 * see [Wiki]( https://bitbucket.org/noalapps/harshama-frontend/wiki/Auto-Fill%20Development%20tool)
 */

export const autoFillForms = (
  componentRef: any,
  options?: AutoFillFormsOptions
) => {
  if (environment.name !== "dev" || EventListnerwasAdded) {
    return;
  }
  document.addEventListener("keydown", (ev) =>
    autoFillFiller(ev, componentRef, options || {})
  );
};



// WEBPACK FOOTER //
// ./src/app/_helpers/auto-fill-forms/auto-fill-forms.ts